<template>
  <v-dialog v-model="dialog" persistent width="620" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title class="text-uppercase">Thông tin tư vấn</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="mb-3">
          <div class="text-body-2 mb-2 black--text font-weight-medium">1. Ngày, giờ làm test</div>
          <div class="d-flex">
            <DatePicker v-model="date" label="Ngày (DD/MM/YYYY)" class="pr-3" style="width: 100%" />
            <TimeInput v-model="time" :selectedDate="getCurrentDate" label="Giờ (HH:mm)" style="width: 100%" />
          </div>
        </div>

        <div class="mb-3">
          <div class="text-body-2 black--text font-weight-medium mb-2">2. Nội dung tư vấn</div>
          <v-textarea v-model="note" label="Nội dung tư vấn" placeholder="Điền nội dung tư vấn" outlined hide-details />
        </div>

        <div>
          <div class="text-body-2 black--text font-weight-medium mb-2">3. Sản phẩm quan tâm (nếu có)</div>
          <div v-for="(product, index) in products" :key="product.id">
            <div class="d-flex justify-space-between pb-6">
              <v-select
                :items="product.selections"
                item-text="title"
                item-value="id"
                v-model="localProfile.products[index]"
                :label="`Chọn sản phẩm quan tâm ${index + 1}`"
                return-object
                outlined
                hide-details
              />
              <v-icon class="ml-6" @click="removeProduct(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <v-spacer />
            <v-btn outlined color="blue darken-4" @click="addProduct">Thêm</v-btn>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" @click="cancel" outlined>Hủy</v-btn>
        <v-spacer />
        <v-btn color="blue darken-4" dark @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import cloneDeep from 'lodash-es/cloneDeep'
import get from 'lodash-es/get'
import moment from 'moment'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import TimeInput from '@/components/basic/TimeInput.vue'

export default {
  components: { DatePicker, TimeInput },
  data: () => ({
    selectedProduct: null,
    localProfile: {},
    products: [],
    dialog: false,
    note: '',
    date: '',
    time: '',
  }),
  computed: {
    ...mapGetters({ profile: 'lead/item', items: 'product/products' }),
    getCurrentDate() {
      return moment().format('DD/MM/YYYY')
    },
  },
  watch: {
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.localProfile = cloneDeep(newProfile)
          this.setFormValues(this.localProfile)
        }
      },
    },
    'profile.products': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.localProfile.products = newVal.map(item => ({ ...item }))
          this.products = newVal.map((item, index) => ({ ...item, selections: this.getAvailableProducts(index) }))
        } else {
          this.localProfile.products = [{}]
          this.products = []
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({ updateLead: 'lead/updateLead' }),
    getTestDate() {
      if (this.date) {
        const res = moment(this.date)
        if (this.time) {
          const timeF = moment(this.time).format('HH:mm')
          const [HH, mm] = timeF.split(':')
          res.hour(HH)
          res.minute(mm)
        }
        return res.toISOString()
      }
      return null
    },
    async onSubmit() {
      const isProductEmpty = product => !product || Object.keys(product).length === 0 || !product.id
      const filteredProducts = this.localProfile.products.filter(product => !isProductEmpty(product))

      try {
        this.$loading.active = true
        const id = this.$route.params.id
        await this.updateLead({
          id,
          products: filteredProducts,
          consultNote: this.note,
          testDate: this.getTestDate(),
          status: 'productVerified',
        })
        this.$emit('refresh')
        this.$alert.success('Đã cập nhập trạng thái khách hàng thành công')
        this.cancel()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    open() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    addProduct() {
      this.products.push({ selections: this.items, id: Date.now() })
      this.localProfile.products.push('')
    },
    removeProduct(index) {
      if (this.localProfile.products.length > 1) {
        this.localProfile.products.splice(index, 1)
      } else {
        this.$set(this.localProfile.products, index, {})
      }
    },
    setFormValues(profile) {
      if (profile.products && profile.products.length > 0) {
        this.localProfile.products = profile.products
      } else {
        this.localProfile.products = [{}]
      }
      this.note = get(this.localProfile, 'consultNote', '')
      const testDate = get(this.localProfile, 'testDate', '')
      if (testDate) {
        this.date = moment(testDate).format('DD/MM/YYYY')
        this.time = moment(testDate).format('HH:mm')
      } else {
        this.date = moment().format('DD/MM/YYYY')
        this.time = moment().format('HH:mm')
      }
    },
    getAvailableProducts(index) {
      const currentProductId = this.localProfile.products[index].id
      return this.items.filter(
        product =>
          product.id === currentProductId ||
          !this.localProfile.products.some(selectedProduct => selectedProduct.id === product.id)
      )
    },
  },
}
</script>
